import DateFilter from '@/components/date-filter';
import Prestation from "@/components/comptable/prestations-exploitations/prestation"
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import store_operation from "@/store/mods/caisse/operations"
import $ from 'jquery'

export default {
    name: 'produits',
    components: {
        DateFilter, Prestation, EnteteBonEtFacture
    },
    props: [],
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            liste_produits_creances: [],

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_loading: true,
            is_empty: false,

            montant_total: 0,
            load_error: false,
            is_printing: false,
            filename: '',
            can_print: false,
            is_month: false,
            personnel_id: "",
            personnel: '',
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }

        },

        curr_month() {
            console.log(this.curr_month);
            this.operations_tobe_canceled = []
            const data = {
                is_creance: 0,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                user_id: this.personnel_id
            }
            this.current_date_filter = data
            this.getProduitExploitation(data)
            this.is_month = true
        },

        personnel() {
            this.personnel_id = this.personnel.id

            this.current_date_filter.user_id = this.personnel_id
            this.getProduitExploitation(this.current_date_filter)
        },
    },

    computed: {
        liste_personnel_roles() {
            return this.$store.getters["liste_personnel_roles"];
        },
    },

    mounted() {
        // this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
        const data = {
            is_creance: 0,
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            user_id: this.personnel_id
        }
        this.current_date_filter = data
        this.getProduitExploitation(data)


        const tmpstamp = this.current_date.getHours()+''+this.current_date.getMinutes()+''+this.current_date.getFullYear()
        this.filename = 'Produits d\'exploitation_'+tmpstamp

        this.$store.dispatch("getRolePersonnels").then(() => {
            const all_user = {
				id: "",
				nom: 'Tous(tes) les caissiers(es)',
                titre: "",
                roles: [],
                email: ""
			}
			this.liste_personnel_roles.unshift(all_user)
        })
    },

    methods: {
        getProduitExploitation(data) {
            this.montant_total = 0
            this.is_loading = true
            this.load_error = false

            store_operation.getListeProduitsCreances(data).then((produits_creances) => {
                this.liste_produits_creances = produits_creances
                if (this.liste_produits_creances.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                    
                    this.liste_produits_creances.forEach(produit => {
                        this.montant_total += produit.montant
                    });
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.load_error = true
            })
        },

        filterByDate(date) {
            const data = {
                is_creance: 0,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                user_id: this.personnel_id
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getProduitExploitation(data)
        },

        printProduitExploitation() {
            this.can_print = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
            }, 500);
        },
    }
}


